<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :key="formContext.isInEditMode"
        :cols="12"
        :form-context="formContext"
        icon="inticon-users"
        title="Anspruchsteller (Versicherer)"
        @save="saveClaimantFormData">
        <template v-if="formContext.permissions.canCreateRetroactiveChangesNote === true" v-slot:after-icons>
            <csp-retroactive-changes-modal :record-id="recordId" title="Anspruchsteller (Versicherer)"/>
        </template>
        <div v-if="showChangelogButton" class="float-right">
            <csp-changelog-modal :changelog-url="claimantChangelogUrl"/>
        </div>
        <h2>Stammdaten</h2>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Anrede"
                property="gender"
                type="radio"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Ansprechpartner Titel"
                property="title"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Ansprechpartner Vorname"
                property="firstName"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Ansprechpartner Nachname"
                property="lastName"
                type="text"/>
        </b-row>
        <hr>
        <h2 class="float-left">
            Versicherungsdaten
        </h2>
        <div v-if="showChangelogButton" class="float-right">
            <csp-changelog-modal :changelog-url="claimantInsuranceChangelogUrl"/>
        </div>
        <div class="clear-float"/>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Schadensnummer-Haftpflicht"
                property="adversaryInsuranceReference"
                type="text"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                v-show="shouldDisplayInsuranceParent"
                class="col-6"
                :form-context="formContext"
                label="Versicherungskonzern"
                :options-loader="loadInsuranceParentOptions"
                property="insuranceParent"
                type="autocomplete">
                <template v-slot:display-value>
                    <span v-if="formContext.data.insuranceName"><b>{{ formContext.data.insuranceName }}</b><br></span>
                    <span v-if="formContext.data.insurancePhone">{{ formContext.data.insurancePhone }}<br></span>
                    <span v-if="formContext.data.insuranceEmail">
                        <a :href="'mailto:' + formContext.data.insuranceEmail">
                            {{ formContext.data.insuranceEmail }}
                        </a>
                    </span>
                </template>
            </csp-desktop-info-card-element>
            <csp-desktop-info-card-element
                v-show="shouldDisplayInsuranceBranch"
                class="col-6"
                :dependencies="['insuranceParent']"
                :form-context="formContext"
                label="Versicherungsfiliale"
                :options-loader="loadInsuranceBranchOptions"
                property="insuranceBranch"
                type="autocomplete">
                <template v-slot:display-value>
                    <span v-if="formContext.data.insuranceName"><b>{{ formContext.data.insuranceName }}</b><br></span>
                    <span v-if="formContext.data.insurancePhone">{{ formContext.data.insurancePhone }}<br></span>
                    <span v-if="formContext.data.insuranceEmail">
                        <a :href="'mailto:' + formContext.data.insuranceEmail">
                            {{ formContext.data.insuranceEmail }}
                        </a>
                    </span>
                </template>
            </csp-desktop-info-card-element>
        </b-row>
    </csp-desktop-info-card>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '../../mixins/FormDataMixin';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'ParticipantClaimant',
        mixins: [FormDataMixin],
        computed: {
            claimantChangelogUrl() {
                return '/api/desktop/records/' + this.recordId + '/participants/claimant/changelog';
            },
            claimantInsuranceChangelogUrl() {
                return '/api/desktop/records/' + this.recordId + '/participants/claimant/insurance/changelog';
            },
            isGenderCompany() {
                return this.formContext.form.getProperty('gender') === 'company';
            },
            personLabelPrefix() {
                if (this.isGenderCompany) {
                    return 'Ansprechpartner ';
                }

                return '';
            },
            recordId() {
                return parseInt(this.$route.params.recordId);
            },
            shouldDisplayInsuranceBranch() {
                if (this.formContext?.isInEditMode) {
                    return true;
                }
                return !!this.formContext?.data['insuranceBranch'];
            },
            shouldDisplayInsuranceParent() {
                if (this.formContext?.isInEditMode) {
                    return true;
                }
                return !this.formContext?.data['insuranceBranch'];
            },
            showChangelogButton() {
                return this.formContext.data.isEntityNew === false
                    && !this.formContext.isInEditMode
                    && this.formContext.permissions.showChangelog === true;
            },
        },
        methods: {
            loadCountryOptions() {
                return recordRepository.loadLegacySelectOptions('countries')
            },
            loadInsuranceBranchOptions() {
                const parentId = this.formContext.form.getProperty('insuranceParent');
                return recordRepository.loadLegacySelectOptions(
                    'childInsurances',
                    {parentInsuranceId: parentId}
                );
            },
            loadInsuranceParentOptions() {
                return recordRepository.loadLegacySelectOptions('parentInsurances');
            },
            saveClaimantFormData(formContext) {
                const saveFunction = (objectId, postData) => {
                    return recordRepository.saveParticipantsClaimant(this.recordId, postData)
                }
                this.saveFormData(formContext, saveFunction, null);
            },
        },
    }
</script>
